import { forwardRef, type InputHTMLAttributes } from "react";
import { cn, toDisplayString } from "@/lib/utils";

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

function safeInputValue(v: unknown): string {
  if (v == null) return "";
  if (typeof v === "string" || typeof v === "number") return String(v);
  return toDisplayString(v);
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = "text", value, placeholder, ...props }, ref) => (
    <input
      type={type}
      ref={ref}
      value={value !== undefined ? safeInputValue(value) : undefined}
      placeholder={placeholder !== undefined ? safeInputValue(placeholder) : undefined}
      className={cn(
        "flex h-9 w-full rounded-md border border-border bg-surface px-3 py-2 text-sm text-text placeholder:text-text-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-transparent focus-visible:border-white/20 disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    />
  )
);
Input.displayName = "Input";
